import { Deserializable } from '../../../models/protocols/deserializable';
import { Address } from '../../../models/users/dto/address';

export class FiduciaryIndividual implements Deserializable {
  public id!: number;
  public memberLegalFiduciaryId!: number;
  public firstName!: string;
  public lastName!: string;
  public birthDate!: string;
  public phoneNumberCountryCode!: string;
  public phoneNumber!: string;
  public email!: string;
  public address!: Address | null;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;
    if (this.address) {
      this.address = Deserialize.instanceOf(Address, this.address);
    }
  }
}
